<template>
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-12">
        <div class="card shadow-sm">
          <!-- 카드 헤더 -->
          <div class="card-header pb-0">
            <nav-pill />
          </div>

          <!-- 카드 바디 -->
          <div class="card-body pt-0">
            <RouterView v-slot="{ Component, route }">
              <Transition name="slide-right" mode="out-in" appear>
                <component :is="Component" :key="route.fullPath" />
              </Transition>
            </RouterView>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavPill from "../components/NavPill.vue";

export default {
  name: "EventCreate",
  components: { NavPill },
};
</script>

<style scoped>
.slide-right-enter-active, .slide-right-leave-active {
  transition: transform .22s ease, opacity .22s ease;
}
.slide-right-enter-from { opacity: 0; transform: translateX(-24px); }
.slide-right-leave-to   { opacity: 0; transform: translateX(24px); }
</style>
